
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sols-asli-women-academy-sawa",
      function () {
        return require("private-next-pages/sols-asli-women-academy-sawa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sols-asli-women-academy-sawa"])
      });
    }
  